import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertService } from '../../../alerts/service/alert.service';
import { VehicleService } from '../../../vehicles/services/vehicle.service';
import { Select2Data, Select2Group, Select2Option } from 'ng-select2-component';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { PanelService } from 'src/app/panel/services/panel.service';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Op } from 'src/app/multiview/models/interfaces';
import { AssociationService } from 'src/app/vehicles/services/association.service';


declare var $: any;

@Component({
  selector: 'app-platform-alerts-create',
  templateUrl: './platform-alerts-create.component.html',
  styleUrls: ['./platform-alerts-create.component.scss'],
})
export class PlatformAlertsCreateComponent implements OnInit {
  options = new Array({ id: 'ALERTS-PLATFORMS', name: 'Alertas Plataforma' });

  public alertForm!: FormGroup;
//AQUI PODEMOS LLAMAR A LAS IMAGENES SELECCIONADAS
canalesImagenes: { [key: string]: string } = {
  'CH1': 'assets/img/canales/ch1.jpg',
  'CH2': 'assets/img/canales/ch2.jpg',
  'CH3': 'assets/img/canales/ch3.jpg',
  'CH4': 'assets/img/canales/ch4.jpg',
  'CH5': 'assets/img/canales/ch5.jpg',
  'CH6': 'assets/img/canales/ch6.jpg',
  'CH7': 'assets/img/canales/ch7.jpg',
  'CH8': 'assets/img/canales/ch8.jpg',
  'CH9': 'assets/img/canales/ch9.jpg',
  'CH10': 'assets/img/canales/ch10.jpg',
  'CH11': 'assets/img/canales/ch11.jpg',
  'CH12': 'assets/img/canales/ch12.jpg',
  'IMG1': 'assets/img/canales/img1.jpg',
  'IMG2': 'assets/img/canales/img2.jpg',
  'IMG3': 'assets/img/canales/img3.jpg',
  'IMG4': 'assets/img/canales/img4.jpg',
  'IMG5': 'assets/img/canales/img5.jpg',
  'IMG6': 'assets/img/canales/img6.jpg',
  'IMG7': 'assets/img/canales/img7.jpg',
  'IMG8': 'assets/img/canales/img8.jpg',
  'IMG9': 'assets/img/canales/img9.jpg',
  'IMG10': 'assets/img/canales/img10.jpg',
  'IMG11': 'assets/img/canales/img11.jpg',
  'IMG12': 'assets/img/canales/img12.jpg',
};
  imagenCanalSeleccionado: string[]=[];

  public events: any = [];

  public loading: boolean = true;

  //AQUI 
  public archivoMultimediaVideoOptions: any[] = [{ label: 'VIDEO', value: 'video' }];
  public archivoMultimediaImagenOptions: any[] = [{ label: 'IMAGEN', value: 'imagen' }];
  public canalesVideo: any[] = [];

  //
  public vehicles: (Select2Group &{operation:number,grupo:number,convoy:number}| Select2Option &{operation:number,grupo:number,convoy:number})[] = [];
  public geocercas: Select2Data = [];
  public geocercasFiltradas: Select2Data = [];
  public geocircles: Select2Data = [];
  public association: Op[]=[];
  public selectedOption: string = 'Filtrar por:';
  public disabledEventSoundActive = false;
  public disabledEmail = true;
  public expirationDate = true;
  public showInfraccion = false;
  public showInfraccionGeocerca = false;
  public showTiempoLimite = false;
  public showFechaCaducidad = true;
  public showGeocercas = true;
  public disabledTimeLimit = true;
  loadingEventSelectInput: boolean = true;
  alertSelected: any;
  public disabledWhatsapp = true;

  archivoMultimediaOptions = [
    { label: 'VIDEO', value: 'video' },
    { label: 'IMAGEN', value: 'imagen' }
  ];
  booleanOptions = [
    { label: 'Sí', value: true },
    { label: 'No', value: false },
  ];

  booleanOptionsVentanaEmergente = [
    { label: 'Activado', value: true },
    { label: 'Desactivado', value: false },
  ];

  listaSonidos: any = [];
  audio = new Audio();

  loadingAlertDropdownReady: boolean = false;
  loadingVehicleMultiselectReady: boolean = false;
  loadingGeofencesMultiselectReady: boolean = false;

  timeFormatOptions = [
    { label: 'segundos', value: 'S' },
    { label: 'minutos', value: 'M' },
    { label: 'horas', value: 'H' },
  ];

  fijarTiempoOptions = [
    { label: '10 Seg.', value: 10 },
    { label: '30 Seg.', value: 30 },
    { label: '1 Min.', value: 60 },
    { label: '2 Min.', value: 120 },
  ];

  booleanOptionsAtencionEventos = [
    { label: 'Activado', value: true },
    { label: 'Desactivado', value: false },
  ];

  selectOperation:number | null= null
  selectGroup:number | null=null
  selectConvoy:number | null=null
  showSelectedCascade:boolean=false
  clearSelectedCascade:boolean=false

  public showMoreFiltersGeocercas = false

  constructor(
    private AlertService: AlertService,
    private VehicleService: VehicleService,
    private formBuilder: FormBuilder,
    public panelService: PanelService,
    private geofencesService: GeofencesService,
    public associationService: AssociationService,
    private spinner: NgxSpinnerService
  ) {
    this.listaSonidos = [...this.AlertService.listaSonidos];
  }

  ngOnInit(): void {
    this.spinner.show('loadingAlertData');
    let dateCurrent = {
      year: moment().year(),
      month: moment().month() + 1,
      day: moment().date(),
    };
    
    this.associationService.getAssociation();
    this.association = this.associationService.association;

    this.alertForm = this.formBuilder.group({
      archivoMultimediaVideo: [''],
      archivoMultimediaImagen: [''],
      vehicles: ['', [Validators.required]],
      geocercas: [[]],
      archivoMultimedia: [[]],
      geocercascirculares: [[]],
      tipoAlerta: ['', [Validators.required]],
      chkEventoActivado: [true],
      chkSonido: [true],
      chkCorreo: [false],
      sonido: [
        {
          value: 'sonidos/alarm8.mp3',
          disabled: this.disabledEventSoundActive,
        },
      ],
      nombre: ['', [Validators.required]],
      lista_emails: [[]],
      email: [
        { value: '', disabled: this.disabledEmail },
        [Validators.required, Validators.email],
      ],
      eventType: ['platform'],
      chkCaducidad: [false],
      chkDuracionParada: [false],
      duracion_parada: [0],
      duracion_formato_parada: [''],
      chkFijarTiempo: [false],
      tiempo_limite_infraccion: [
        { value: '', disabled: this.disabledTimeLimit },
      ],
      chkFijarLimiteVelocidad: [false],
      velocidad_limite_infraccion: [{ value: '', disabled: true }],
      chkwhatsapp: [false],
      lista_whatsapp: [[]],
      whatsapp: [
        { value: '', disabled: this.disabledWhatsapp },
        [Validators.required],
      ],
      chkVentanaEmergente: [false],
      chkEvaluation: [false],
    });
    this.generateChannels();
    this.loading = false;
    this.loadData();
  }

  //esto es para generar los canales
  generateChannels() {
    this.canalesVideo = Array.from({ length: 12 }, (_, i) => ({
      label: `CH${i + 1}`,
      value: `CH${i + 1}`
    }));
  
    this.archivoMultimediaVideoOptions = [{ label: 'VIDEO', value: 'video' }];
    this.archivoMultimediaImagenOptions = [{ label: 'IMAGEN', value: 'imagen' }];
  
    this.canalesVideo.forEach(canal => {
      this.archivoMultimediaVideoOptions.push({
        label: `VIDEO ${canal.label}`,
        value: canal.value
      });
      this.archivoMultimediaImagenOptions.push({
        label: `IMAGEN ${canal.label}`,
        value: canal.value
      });
    });
  }
  


  actualizarOpcionesVideo(event: any) {
    if (event.value.includes('video')) {
      this.archivoMultimediaVideoOptions = [
        { label: 'VIDEO', value: 'video' },
        ...this.canalesVideo.map(canal => ({
          label: `VIDEO ${canal.label}`,
          value: canal.value
        }))
      ];
      this.alertForm.controls['archivoMultimediaVideo'].setValue([]);
    }
  
    if (event.value.includes('imagen')) {
      this.archivoMultimediaImagenOptions = [
        { label: 'IMAGEN', value: 'imagen' },
        ...this.canalesVideo.map(canal => ({
          label: `IMAGEN ${canal.label}`,
          value: canal.value
        }))
      ];
      this.alertForm.controls['archivoMultimediaImagen'].setValue([]);
    }
  }
  
  public async loadData() {
    this.events = await this.AlertService.getEventsByType('platform');
    console.log('EVENTSSS:::::', this.events);
    this.archivoMultimediaVideoOptions = this.archivoMultimediaOptions.filter(option => option.value === 'video');
    this.archivoMultimediaImagenOptions = this.archivoMultimediaOptions.filter(option => option.value === 'imagen');
    this.loadingEventSelectInput = false;
    this.setDataVehicles();
    this.setDataGeofences().then(()=>{
      this.loadingAlertDropdownReady = true;
      this.hideLoadingSpinner();
      this.changeVehicles(true)
      console.log(this.listGeocercas, "datos cargoad")
    }).catch(()=>{
      this.loadingAlertDropdownReady = true;
      this.hideLoadingSpinner();
    });

  }

  changeVehicles(event: any) {
    console.log('event::::', event, this.selectedOperations);
    const operations = new Set();
    console.log('OPERATIONS::::', operations);
    this.geocercasFiltradas = this.geocercas.filter((geofence) =>
      operations.has(geofence.templateId)
    );
    const geocercasVehicles = this.listGeocercas

    console.log('VEHICLES FILTERS::::', this.geocercasFiltradas, geocercasVehicles);
    console.log('VEHICLES FILTERS APLY OPERACTION::::', this.selectedOperations);
    console.log('VEHICLES FILTERS APLY LABELS::::', this.selectedEtiquetas);

    let geocercasFiltradas = geocercasVehicles
    if(this.showMoreFiltersGeocercas){
      geocercasFiltradas = geocercasVehicles.filter((geo) => {
        const geotags = geo.tags || []; // Asegurar que exista una lista
        const matchOperacion = this.selectedOperations.includes(geo.idoperation);
        const matchEtiqueta = geotags.some((tag : any) => this.selectedEtiquetas.includes(tag));
        return matchOperacion && matchEtiqueta;
      });
    }
    this.geocercasFiltradas = geocercasFiltradas.map((geocerca: any) => ({
      value: geocerca.id,
      label: geocerca.zone_name,
      templateId: geocerca.idoperation,
    }));
    console.log('geocercasFiltradas::::', this.geocercasFiltradas, geocercasFiltradas);
  }

  filterGeocercas() {
    console.log('VEHICLES FILTERS APLY OPERACTION::::', this.selectedOperations);
    console.log('VEHICLES FILTERS APLY LABELS::::', this.selectedEtiquetas);

  }
  setDataVehicles() {
    let vehicles = this.VehicleService.getVehiclesData();

    this.vehicles = vehicles.map((vehicle: any) => {
      return {
        value: vehicle.id,
        label: vehicle.name,
        templateId: vehicle.idoperation,
        operation:vehicle.idoperation,
        grupo:vehicle.idgrupo,
        convoy:vehicle.idconvoy,
      };
    });

    this.loadingVehicleMultiselectReady = true;
    //this.hideLoadingSpinner();
  }

  public listOperations : any[] = []
  public listEtiquetas : any[] = []
  public listGeocercas : any[] = []

  public selectedOperations : any = []
  public selectedEtiquetas : any = []

  selectMoreFilters() {
    console.log("more filters", this.showMoreFiltersGeocercas)
    this.showMoreFiltersGeocercas = !this.showMoreFiltersGeocercas
    this.changeVehicles(true)
  }

  setDataGeofences(): Promise<any[]> {
    return new Promise((resolve) => {
      if (this.geofencesService.initializingGeofences === true) {
        const geocercas = this.geofencesService.getData();
        this.geocercas = geocercas.map((geocerca: any) => ({
          value: geocerca.id,
          label: geocerca.zone_name,
          templateId: geocerca.idoperation,
        }));
        this.geocercasFiltradas = this.geocercas;
        this.loadingGeofencesMultiselectReady = true;
        this.listOperations = geocercas
          .map((v: any) => {
            let operation: any = {
              name: v.nameoperation ?? '',
              key: v.idoperation ?? 0,
            };
            return operation;
          })
          .reduce((acc: any[], _: any) => {
            if (!acc.some((o) => o.key === _.key)) {
              acc.push(_);
            }
            return acc;
          }, []);
        this.listEtiquetas = this.geofencesService.listTag
        this.listGeocercas = geocercas
        resolve(this.geocercas); // ✅ retornamos el resultado
      } else {
        this.geofencesService.dataCompleted.subscribe(() => {
          const geocercas = this.geofencesService.getData();
          this.geocercas = geocercas.map((geocerca: any) => ({
            value: geocerca.id,
            label: geocerca.zone_name,
            templateId: geocerca.idoperation,
          }));
          this.geocercasFiltradas = this.geocercas;
          this.loadingGeofencesMultiselectReady = true;
          this.listOperations = geocercas
          .map((v: any) => {
            let operation: any = {
              name: v.nameoperation ?? '',
              key: v.idoperation ?? 0,
            };
            return operation;
          })
          .reduce((acc: any[], _: any) => {
            if (!acc.some((o) => o.key === _.key)) {
              acc.push(_);
            }
            return acc;
          }, []);
        this.listEtiquetas = this.geofencesService.listTag
        this.listGeocercas = geocercas

          resolve(this.geocercas); // ✅ retornamos el resultado cuando termina
        });
      }
    });
  }


  restEmail(index: any) {
    this.alertForm.value.lista_emails.splice(index, 1);
  }

  clickShowPanel(nomComponent: string): void {
    $('#panelMonitoreo').show('slow');
    this.panelService.nombreComponente = nomComponent;

    const item = this.options.filter((item) => item.id == nomComponent);
    this.panelService.nombreCabecera = item[0].name;
  }

  changeDisabled() {
    if (this.alertForm.value.chkSonido) {
      this.alertForm.controls['sonido'].enable();
    } else {
      this.alertForm.controls['sonido'].disable();
    }
  }

  playAudio(path: string) {
    if (typeof path != 'undefined' && path != '') {
      if (this.audio.currentSrc != '' && !this.audio.ended) {
        this.audio.pause();
      }
      this.audio = new Audio('assets/' + path);
      let audioPromise = this.audio.play();

      if (audioPromise !== undefined) {
        audioPromise
          .then(() => {
            //console.log('Playing notification sound')
          })
          .catch((error: any) => {
            //console.log(error);
            // Auto-play was prevented
          });
      }
    }
  }

  onSubmit(event: any) {
    event.preventDefault();

    // this.alertForm.value.vehiculos = JSON.stringify(
    //   this.alertForm.value.vehicles
    // );
    // this.alertForm.value.vehicles = null;

    // this.alertForm.value.geocercas = JSON.stringify(
    //   this.alertForm.value.geocercas
    // );
    // this.alertForm.value.geocercascirculares = JSON.stringify(
    //   this.alertForm.value.geocercascirculares
    // );

    /*this.alertForm.value.fecha_desde = this.setDate(
      this.alertForm.value.fecha_desde
    );
    this.alertForm.value.fecha_hasta = this.setDate(
      this.alertForm.value.fecha_hasta
    );*/

    if (this.alertForm.value.duracion_formato_parada == '') {
      this.alertForm.value.duracion_formato_parada = 'S';
    }

    if (typeof this.alertForm.value.tiempo_limite_infraccion == 'undefined') {
      this.alertForm.value.tiempo_limite_infraccion = 0;
    }

    if (typeof this.alertForm.value.sonido == 'undefined') {
      this.alertForm.value.sonido = 'sonidos/alarm8.mp3';
    }

    if (
      typeof this.alertForm.value.velocidad_limite_infraccion == 'undefined'
    ) {
      this.alertForm.value.velocidad_limite_infraccion = 0;
    }

    if (
      this.alertForm.value.chkCorreo &&
      this.alertForm.value.lista_emails.length == 0
    ) {
      Swal.fire('Error', 'Debe ingresar un correo', 'warning');
      return;
    }

    if (
      this.alertForm.value.chkwhatsapp &&
      this.alertForm.value.lista_whatsapp.length == 0
    ) {
      Swal.fire('Error', 'Debe ingresar un número', 'warning');
      return;
    }

    const vehicles = this.alertForm.value.vehicles || [];

    if (
      this.alertForm.value.vehicles.length != 0 &&
      this.alertForm.value.nombre.trim() != '' &&
      this.alertForm.value.tipoAlerta.length != 0
    ) {
      console.log('ANTES DE GUARDAR: ', this.alertForm.value);

      this.alertForm.value.vehiclesIds = JSON.stringify(vehicles);
      this.alertForm.value.vehicles = null;
      this.alertForm.value.geocercas = JSON.stringify(
        this.alertForm.value.geocercas
      );
      this.alertForm.value.geocercascirculares = JSON.stringify(
        this.alertForm.value.geocercascirculares
      );

      Swal.fire({
        title: '¿Desea guardar los cambios?',
        //text: 'Espere un momento...',
        icon: 'warning',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        preConfirm: async () => {
          await this.AlertService.create(this.alertForm.value);
          this.AlertService.getAll();
          this.clickShowPanel('ALERTS-PLATFORMS');
        },
      }).then((data) => {
        if (data.isConfirmed) {
          Swal.fire(
            'Datos guardados',
            'Los datos se guardaron correctamente!!',
            'success'
          );
        }
      });
    } else {
      // Swal.fire('Error', 'Debe seleccionar un vehículo', 'warning');
      if (this.alertForm.value.vehicles.length === 0) {
        Swal.fire(
          '¡Atención!',
          'Debe seleccionar al menos un vehículo para completar la acción.',
          'warning'
        );
      }
      if (this.alertForm.value.nombre.trim() === '') {
        Swal.fire(
          '¡Atención!',
          'Debe ingresar el nombre de la alerta',
          'warning'
        );
      }
      if (this.alertForm.value.tipoAlerta.length === 0) {
        Swal.fire(
          '¡Atención!',
          'Debe seleccionar el tipo de alerta',
          'warning'
        );
      }
    }
  }

  chkEmailHandler() {
    if (this.alertForm.value.chkCorreo) {
      this.alertForm.controls['email'].enable();
    } else {
      this.alertForm.controls['email'].disable();
    }
  }

  addEmail() {
    if (this.alertForm.value.chkCorreo) {
      if (this.validateEmail(this.alertForm.value.email)) {
        if (
          !this.isInArray(
            this.alertForm.value.email,
            this.alertForm.value.lista_emails
          )
        ) {
          this.alertForm.value.lista_emails.push(this.alertForm.value.email);
          this.alertForm.controls.email.reset();
        } else {
          Swal.fire({
            title: 'Error',
            text: 'El email ingresado ya existe.',
            icon: 'warning',
            allowOutsideClick: false,
          });
        }
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Debe ingresar un email válido.',
          icon: 'warning',
          allowOutsideClick: false,
        });
      }
    }
  }

  validateEmail(email: any) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  isInArray(value: any, array: any[]) {
    return array.indexOf(value) > -1;
  }

  changeDisabledExpirationDate($event: any) {
    this.expirationDate = !this.expirationDate;
  }

  setDate(date: any) {
    return moment({
      year: date.year,
      month: date.month - 1,
      day: date.day,
    })
      .format('YYYY-MM-DD')
      .toString();
  }

  changeAlertType() {
    console.log('cambioalerta', this.alertForm.value.tipoAlerta);
    const alert = this.events.find(
      (event: any) =>
        event.id.toString() === this.alertForm.value.tipoAlerta.toString()
    );
    this.alertSelected = alert;
    /* console.log('alerttt', alert); */

    // INICIO SONIDOS PERSONALIZADOS

    if (alert) {
      this.alertSelected = alert;
      console.log('alerttt', alert);

      // Obtén todos los elementos de la lista de sonidos hasta el id 27
      let sonidosObtenidos = this.AlertService.listaSonidos.filter(
        (sonido: { id: any }) => sonido.id <= 26
      );

      if (alert.name === 'Infracción') {
        const vozPersonalizada = this.AlertService.listaSonidos.find(
          (sonido: { id: any }) => sonido.id === 35
        );
        if (vozPersonalizada) {
          sonidosObtenidos = [vozPersonalizada, ...sonidosObtenidos];
        }
      } else if (alert.name === 'Exceso de Velocidad') {
        const vozPersonalizada = this.AlertService.listaSonidos.find(
          (sonido: { id: any }) => sonido.id === 32
        );
        if (vozPersonalizada) {
          sonidosObtenidos = [vozPersonalizada, ...sonidosObtenidos];
        }
      }

      if (sonidosObtenidos.length > 0) {
        console.log('Sonidos obtenidos:', sonidosObtenidos);
        this.listaSonidos = sonidosObtenidos;
      } else {
        console.log(
          'No se encontraron sonidos para la alerta seleccionada o la función no devuelve un array.'
        );
      }
    } else {
      this.listaSonidos = this.AlertService.listaSonidos.filter(
        (sonido: { id: any }) => sonido.id <= 26
      );

      if (this.listaSonidos.length > 0) {
        console.log('Sonidos obtenidos:', this.listaSonidos);
      } else {
        console.log('No se encontraron sonidos para la alerta seleccionada.');
      }
    }

    // FIN SONIDOS PERSONALIZADOS

    this.alertForm.value.velocidad_limite_infraccion = 0;
    if (this.alertSelected.slug == 'infraccion') {
      this.alertForm.controls['velocidad_limite_infraccion'].enable();
      this.alertForm.value.chkFijarLimiteVelocidad = [true];
    } else {
      this.alertForm.controls['velocidad_limite_infraccion'].disable();
    }
    switch (alert.slug) {
      case 'zona-de-entrada':
      case 'zona-de-salida':
        this.showTiempoLimite = false;
        this.showFechaCaducidad = false;
        this.showGeocercas = true;
        this.showInfraccion = false;
        this.showInfraccionGeocerca = false;
        break;

      case 'tiempo-estadio-zona':
      case 'parada-en-zona-no-autorizada':
      case 'parada-en-zona-no-programada':
        this.showTiempoLimite = true;
        this.showFechaCaducidad = false;
        this.showGeocercas = true;
        this.showInfraccion = false;
        this.showInfraccionGeocerca = false;
        break;
      case 'transito-lento':
        this.showTiempoLimite = true;
        this.showFechaCaducidad = false;
        this.showGeocercas = true;
        this.showInfraccion = false;
        this.showInfraccionGeocerca = true;
        break;
      case 'infraccion':
        this.showTiempoLimite = false;
        this.showFechaCaducidad = false;
        this.showGeocercas = false;
        this.showInfraccion = true;
        this.showInfraccionGeocerca = false;
        break;

      case 'infraccion-geocerca':
        this.showTiempoLimite = false;
        this.showFechaCaducidad = false;
        this.showGeocercas = true;
        this.showInfraccion = false;
        this.showInfraccionGeocerca = true;
        break;
      case 'exceso-velocidad':
        this.showTiempoLimite = false;
        this.showFechaCaducidad = false;
        this.showGeocercas = true;
        this.showInfraccion = false;
        this.showInfraccionGeocerca = false;
        break;
      case 'infraccion-geocerca-direccion':
        this.showTiempoLimite = false;
        this.showFechaCaducidad = false;
        this.showGeocercas = true;
        this.showInfraccion = false;
        this.showInfraccionGeocerca = true;
        break;
      default:
        break;
    }
  }

  resetForm() {
    this.alertForm.reset();
  }
  changechkFijarTiempo() {
    if (this.alertForm.value.chkFijarTiempo) {
      this.alertForm.controls['tiempo_limite_infraccion'].enable();
      this.alertForm.controls['chkFijarLimiteVelocidad'].disable();
    } else {
      this.alertForm.controls['tiempo_limite_infraccion'].disable();
      this.alertForm.controls['chkFijarLimiteVelocidad'].enable();
    }
  }

  changechkFijarLimiteVelocidad() {
    if (this.alertForm.value.chkFijarLimiteVelocidad) {
      this.alertForm.controls['velocidad_limite_infraccion'].enable();
      this.alertForm.controls['chkFijarTiempo'].disable();
    } else {
      this.alertForm.controls['velocidad_limite_infraccion'].disable();
      this.alertForm.controls['chkFijarTiempo'].enable();
    }
  }

  hideLoadingSpinner() {
    if (
      this.loadingAlertDropdownReady &&
      this.loadingVehicleMultiselectReady &&
      this.loadingGeofencesMultiselectReady
    ) {
      this.spinner.hide('loadingAlertData');
    }
  }

  addWhatsapp() {
    if (this.alertForm.value.chkwhatsapp) {
      if (this.alertForm.value.whatsapp) {
        if (
          !this.isInArray(
            this.alertForm.value.whatsapp,
            this.alertForm.value.lista_whatsapp
          )
        ) {
          this.alertForm.value.lista_whatsapp.push(
            this.alertForm.value.whatsapp
          );
          this.alertForm.controls.whatsapp.reset();
        } else {
          Swal.fire({
            title: 'Error',
            text: 'El número ingresado ya existe.',
            icon: 'warning',
          });
        }
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Debe ingresar un número.',
          icon: 'warning',
        });
      }
    }
  }

  restWhatsapp(index: number) {
    this.alertForm.value.lista_whatsapp.splice(index, 1);
  }

  chkWhatsappHandler() {
    if (this.alertForm.value.chkwhatsapp) {
      this.alertForm.controls['whatsapp'].enable();
    } else {
      this.alertForm.controls['whatsapp'].disable();
    }
  }

  selectGeneral(id?:number,type?:string){
    // if (event) {
    //   event.stopPropagation();
    // }

    if (id!=undefined && type!=undefined) {
      
      if (type=='operation') {
        this.selectOperation=id

      }
      if (type=='groups') {
        this.selectGroup=id
      }
      if (type=='convoy') {
        this.selectConvoy=id
        console.log('Convoy seleccionado:', id);
      }
    }else{
      this.showSelectedCascade=!this.showSelectedCascade
    }
  }

  savefilterbyclick(id?:number,type?:string){
    if (type=='operation') {
      this.selectGroup=null
      this.selectConvoy=null
      
    }
    if (type=='groups') {
      this.selectConvoy=null
    }
    
    this.selectedOption=''
    console.log(this.selectOperation,':', this.selectGroup,';',this.selectConvoy,this.association);
    this.showSelectedCascade=false;
    if (this.selectOperation!=null) {
      const o=this.association.find((_)=>_.id==this.selectOperation)
      this.selectedOption+=o?.name
      if (this.selectGroup!=null) {
        const g=o?.operationGroups.find((_)=>_.id==this.selectGroup)
        this.selectedOption+=' / '+g?.name
        if (this.selectConvoy!=null) {
          const c=g?.convoyList.find((_)=>_.id==(this.selectConvoy))
          this.selectedOption+=' / '+c?.name
        }
      }
    }
    if (this.selectOperation!=null || this.selectGroup!=null || this.selectConvoy!=null) {
      this.clearSelectedCascade=true
    }
    this.filterVehicleByCascadeSelected()
  }

  clearSelectCascade(event:Event){
    event.stopPropagation()
    this.selectOperation=null
    this.selectGroup=null
    this.selectConvoy=null
    this.showSelectedCascade=false 
    this.clearSelectedCascade=false
    this.selectedOption='Filtrar por:'
    this.setDataVehicles()
  }
  filterVehicleByCascadeSelected(){
    this.setDataVehicles()
    this.vehicles=this.vehicles.filter((vehicle)=>{
      if(this.selectOperation!=null){
        if (this.selectGroup!=null) {
          if (this.selectConvoy!=null) {
            return this.selectConvoy==vehicle.convoy && this.selectGroup==vehicle.grupo && this.selectOperation==vehicle.operation
          } else {
            return this.selectGroup==vehicle.grupo && this.selectOperation==vehicle.operation
          }
        }else{
          return this.selectOperation==vehicle.operation
        }
      }else{
        return true
      }
  })
  }

  mostrarImagenCanal(event: any) {
    if (event.value.length > 0) {
        this.imagenCanalSeleccionado = event.value
            .map((canal: string) => this.canalesImagenes[canal] || '')
            .filter((img: string) => img !== '');
    } else {
        this.imagenCanalSeleccionado = [];
    }
}
}
